// extracted by mini-css-extract-plugin
export default {"container":"searchIconInput_container__bvM23"};